import { Action, createAction, props } from '@ngrx/store';
import { ApiKey } from '@shared/models/api-management/api-key';

import { ModalState } from './modal.reducer';

export enum ModalActionTypes {
  Show = '[Modal] Show',
  Confirm = '[Modal] Confirm button clicked',
  Cancel = '[Modal] Cancel button clicked',
  Reset = '[Modal] Reset',
  ShowNoteModal = '[Modal] Note modal show',
  ShowNoteDeclinedModal = '[Modal] Note Declined modal show',
}

export class ModalShow implements Action {
  readonly type = ModalActionTypes.Show;
  constructor(public payload: Partial<ModalState>, public confirmAction?: Action) {}
}

export class ModalConfirm implements Action {
  readonly type = ModalActionTypes.Confirm;
  constructor(
    public payload: {
      content?: string;
      redirectUrl?: string;
    } = {},
  ) {}
}

export class ModalCancel implements Action {
  readonly type = ModalActionTypes.Cancel;
}

export class ModalReset implements Action {
  readonly type = ModalActionTypes.Reset;
}

export class NoteModalShow implements Action {
  readonly type = ModalActionTypes.ShowNoteModal;
  constructor(public payload: Partial<ModalState>, public confirmAction?: Action) {}
}

export const showModalApiKey = createAction(
  '[Modal] Show modal Api Key',
  props<{
    payload?: Partial<ModalState> & { apiKey?: ApiKey };
  }>(),
);

export const noteRejectedModalShow = createAction(
  '[Modal] Note Rejected modal show',
  props<{
    payload: Partial<ModalState> & { jobId: number; candidateId?: number; subStatus: string };
  }>(),
);

export const noteBatchRejectedModalShow = createAction(
  '[Modal] Note Batch Rejected modal show',
  props<{
    payload: Partial<ModalState> & {
      jobId: number;
      candidateIds?: string[];
      phaseId: string;
      rejectionStateId: string;
    };
  }>(),
);

export const noteBatchMoveForwardModalShow = createAction(
  '[Modal] Note Batch Move Forward modal show',
  props<{
    payload: Partial<ModalState> & {
      jobId: number;
      candidateIds?: string[];
      totalMatchesAssign?: boolean;
    };
  }>(),
);
